<template>
    <div>
        <select v-model="value" @change="addMeta()">
            <option v-if="index >= from" v-for="index in to" :key="index">{{ index }}</option>
        </select>
        <div style="color: red" v-if="value === 0">Please specify how many people will be in your party? (Max. 6)</div>
    </div>
</template>

<script>
export default {
    name: 'add-meta-select',
    props: ['index', 'name', 'from', 'to', 'savedValue'],
    data(){
        return {
            value: this.savedValue
        }
    },
    methods:{
        addMeta(){
            axios.post('/basket/add-meta',{
                index: this.index,
                metaItemName: this.name,
                metaItemValue: this.value
            }).then((response)=>{
                window.location.reload();
            })
        }
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// resources/js/components/Basket/Add-meta-to-cart.vue